import DOM from 'quickdom'

export default DOM.template(
	['div'
		ref: 'field'
		style:
			position: 'relative'
			display: 'none'
			width: (field)-> field.state.width
			boxSizing: 'border-box'
			fontFamily: (field)-> field.settings.fontFamily
			textAlign: 'left'
			$visible:
				display: 'inline-block'
			$showError:
				animation: '0.2s fieldErrorShake'
	

		['div'
			ref: 'label'
			style:
				display: 'none'
				marginBottom: '5px'
				fontFamily: 'inherit'
				fontSize: '15px'
				fontWeight: 600
				color: '#181818'
				cursor: 'default'
				pointerEvents: 'none'
				userSelect: 'none'
				textAlign: 'center'
				$showLabel:
					display: 'block'
				$showError:
					color: '#cc4820'
		]
		
		['div'
			ref: 'innerwrap'
			style:
				position: 'relative'
				boxSizing: 'border-box'
				fontFamily: 'inherit'
		]

		['div'
			ref: 'help'
			style:
				marginTop: '10px'
				fontFamily: 'inherit'
				fontSize: '11px'
				color: '#909090'
				display: 'none'
				$showError:
					color: '#cc4820'
					display: 'block'
				$showHelp:
					display: 'block'
		]
	]
)




export choiceGroup = DOM.template(
	['div'
		ref: 'choiceGroup'
		style: 
			marginBottom: (field)-> field.settings.spacing
			userSelect: 'none'
			fontSize: '0'
			whiteSpace: 'nowrap'
			display: 'flex'
			justifyContent: 'space-around'
			flexWrap: 'wrap'
			maxWidth: 370
			margin: '0 auto'
	]
)



export choice = DOM.template(
	['div'
		ref: 'choice'
		styleAfterInsert: true
		style:
			position: 'relative'
			marginLeft: ()-> if @index then 12
			marginTop: 23
			# minHeight: '46px'
			fontFamily: 'inherit'
			textAlign: 'center'
			color: '#181818'
			boxSizing: 'border-box'
			cursor: 'pointer'
			$definedWidth:
				width: (field)-> "calc((100% - #{field.settings.spacing * (field.settings.perGroup-1)}px) / #{field.settings.perGroup})"
			$selected:
				color: '#fac50a'
			$unavailable:
				display: 'none'
			$disabled:
				cursor: 'not-allowed'
				opacity: 0.7
				color: '#909090'
		
		['div'
			ref: 'preview'
			style:
				boxSizing: 'border-box'
				width: 59
				height: 59
				padding: 7
				margin: '0 auto'
				borderRadius: 5
				backgroundColor: '#e2e6ec'

			['div'
				style:
					width: '100%'
					height: '100%'
					borderRadius: 5
				computers: gradient: ([from, to])->
					@style background:"linear-gradient(-45deg, #{from}, #{to})"
			]
		]

		['div'
			ref: 'label'
			style:
				position: 'relative'
				display: 'block'
				padding: '13px 0px 10px'
				fontFamily: 'inherit'
				fontSize: 14
				fontWeight: '500'
				textAlign: 'center'
		]
		
		['div'
			ref: 'indicator'
			style:
				boxSizing: 'border-box'
				position: 'relative'
				width: 20
				height: 20
				margin: '0 auto'
				border: '1px solid #dce0e6'
				backgroundColor: 'white'
				borderRadius: 500

			['div'
				ref: 'selected'
				style:
					position: 'absolute'
					left: '50%'
					top: '50%'
					width: 12
					height: 12
					borderRadius: 500
					backgroundColor: '#fac50a'
					transform: 'translate(-50%, -50%) scale(0)'
					transition: 'transform 120ms'
					$selected:
						transform: 'translate(-50%, -50%) scale(1)'
			]
		]
	]
)




